import { NitroIcon } from 'nitro-components';
import React, { PropTypes } from 'react';

import { GlobalSearchSection, GlobalSearchDeskTopDropDown } from './css';
import { GlobalSearchTypeDropdown } from './GlobalSearchTypeDropdown';

import { SEARCH_RESULT } from '../../../routes/const';
import { SEARCH_TYPE_MAP } from './store/TYPES';

const GlobalSearchBar = (
  {
    categoryHistory,
    history,
    isFetchingCategoryHistory,
    isFetchingHistory,
    inputText,
    onInput,
    showHistory,
    setShowHistory,
    selected,
    onSelect,
    // actions
    fetchSearchBarCategoryHistory,
    fetchSearchBarHistory
  },
  context
) => {
  const globalSearch = () => {
    if (inputText !== '') {
      onInput({ inputText, fetch: true });
      context.router.push(SEARCH_RESULT);
    }
  };

  const closeHistory = () => {
    setTimeout(() => {
      setShowHistory(false);
    }, 750);
  };

  const handleBodyClick = (event, { searchTerm, type }) => {
    event.stopPropagation();
    onSelect({ label: type, value: type });
    onInput({ inputText: searchTerm, fetch: true });
    if (window.location.pathname !== SEARCH_RESULT) {
      context.router.push(SEARCH_RESULT);
    }
    setTimeout(() => {
      onInput({ inputText: searchTerm, fetch: true });
      setShowHistory(false);
    }, 250);
  };

  const getHistory = () => {
    if (!isFetchingHistory) {
      fetchSearchBarHistory({
        offset: 0,
        limit: 10,
        lookup: '',
        sort: null
      });
    }
  };

  const getCategoryHistory = () => {
    if (!isFetchingCategoryHistory) {
      fetchSearchBarCategoryHistory({
        offset: 0,
        limit: 5,
        lookup: '',
        sort: null,
        historyCategory: SEARCH_TYPE_MAP[selected]
      });
    }
  };

  const filteredHistory = history
    .filter(({ HistoryCategory }) => HistoryCategory !== selected)
    .slice(0, 5);

  return (
    <GlobalSearchSection>
      <GlobalSearchDeskTopDropDown>
        <GlobalSearchTypeDropdown selected={selected} onSelect={onSelect} />
      </GlobalSearchDeskTopDropDown>

      <input
        placeholder="Search"
        value={inputText}
        onFocus={() => {
          setShowHistory(true);
          getHistory();
          getCategoryHistory();
        }}
        onChange={e => {
          onInput(e.target.value);
        }}
        onKeyDown={e => {
          if (e.key === 'Enter' && inputText) {
            closeHistory();
            globalSearch();
          }
        }}
        onBlur={closeHistory}
      />
      {showHistory && !isFetchingHistory && !isFetchingCategoryHistory && (
        <ul>
          {categoryHistory && <p>RECENT {selected} SEARCHES</p>}
          {categoryHistory &&
            categoryHistory.map(item => (
              // eslint-disable-neitemt-line jsx-a11y/no-noninteractive-element-interactions
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <li
                key={item.Id}
                onClick={e =>
                  handleBodyClick(e, {
                    searchTerm: item.SearchTerm,
                    type: item.HistoryCategory
                  })
                }>
                <NitroIcon name="recent" variant="base2" size="16" />
                {item.SearchTerm}
              </li>
            ))}
          {history && <p>RECENT SEARCHES</p>}
          {history &&
            filteredHistory.map(item => (
              // eslint-disable-neitemt-line jsx-a11y/no-noninteractive-element-interactions
              // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions
              <li
                key={item.Id}
                onClick={e =>
                  handleBodyClick(e, {
                    searchTerm: item.SearchTerm,
                    type: item.HistoryCategory
                  })
                }>
                <NitroIcon name="recent" variant="base2" size="16" />
                {item.SearchTerm}
              </li>
            ))}
        </ul>
      )}

      {inputText !== '' && !showHistory ? (
        <NitroIcon
          name="close"
          variant="brownGrey"
          action={() => onInput('')}
        />
      ) : (
        <NitroIcon name="search" action={globalSearch} />
      )}
    </GlobalSearchSection>
  );
};

GlobalSearchBar.contextTypes = {
  router: PropTypes.shape({})
};

GlobalSearchBar.propTypes = {
  categoryHistory: PropTypes.arrayOf(PropTypes.shape({})),
  history: PropTypes.arrayOf(PropTypes.shape({})),
  isFetchingHistory: PropTypes.bool,
  isFetchingCategoryHistory: PropTypes.bool
};

GlobalSearchBar.defaultProps = {
  categoryHistory: [],
  history: [],
  isFetchingHistory: false,
  isFetchingCategoryHistory: false
};
export default GlobalSearchBar;



// WEBPACK FOOTER //
// ./src/features/common/GlobalSearchBar/GlobalSearchBarComponent.js